<template>
	<div
		:class="['default-upload-mode el-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
		@focus="focusing = true"
		@blur="focusing = false"
		@click="focusing = false"
	>
		<template v-if="file.status === 'success'">
			<img
				v-if="fileIsImage(file.response.extension)"
				class="el-upload-list__item-thumbnail image responsive"
				:src="file.response.path"
				:alt="file.response.file_name"
			/>
			<FileIcon v-else class="el-upload-list__item-thumbnail text-6xl flex items-center justify-center p-8" :extension="file.response.extension"/>
			<label class="el-upload-list__item-status-label">
				<i class="el-icon-upload-success el-icon-check"></i>
			</label>
			<span class="item-footer el-upload-list__item-footer flex flex-col">
				<div class="actions item-footer__actions flex justify-around py-1">
					<i
						class="actions__item el-icon-zoom-in"
						:title="$t('Actions.Preview')"
						@click="$emit('onClickPreview', file)"
					/>
					<i
						class="actions__item el-icon-download"
						:title="$t('Actions.Download')"
						@click="$emit('onClickDownload', file)"
					/>
					<i
						v-if="isEditable"
						class="actions__item el-icon-delete"
						:title="$t('Actions.Delete')"
						@click="$emit('onClickRemove', file)"
					/>
				</div>
				<div class="item-footer__file-name h-full flex items-center leading-none px-2 text-sm" :title="file.response.file_name">
					<span class="w-full truncate text-center">{{ file.response.file_name }}</span>
				</div>
			</span>
		</template>
		<el-progress
			v-else
			type="circle"
			:stroke-width="6"
			:percentage="file.percentage ? parsePercentage(file.percentage) : 0"
		/>
	</div>
</template>

<script>
import FileIcon from "./FileIcon";

export default {
	name: "DefaultUploadMode",
	components: { FileIcon },
	props: {
		file: {
			type: Object,
			required: true
		},
		isEditable: {
			type: Boolean,
			required: true
		}
	},
	emits: {
		onClickRemove: {},
		onClickPreview: {},
		onClickDownload: {}
	},
	data() {
		return { focusing: false };
	},
	methods: {
		parsePercentage(val) {
			return parseInt(val, 10);
		}
	}
};
</script>

<style lang="scss" scoped>
.default-upload-mode {
	&.el-upload-list__item {
		margin: 0 8px 4px 0;

		&:hover {
			.el-upload-list__item-status-label {
				display: block;
			}
		}

		.el-upload-list__item-footer {
			position: absolute;
			text-align: center;
			width: 100%;
			height: 35%;
			bottom: 0;
			font-size: 20px;
			color: #fff;
			background-color: rgba(0,0,0,.5);
			transition: opacity .3s;

			.item-footer__actions {
				.actions__item {
					cursor: pointer;
					display: block;
				}
			}


		}
	}
}
</style>

